module.exports = __webpack_public_path__ + "img/IMG_0833.aac5866c.png";